export default {
  getList: {
    method: 'post',
    url: '/client/company/group/list'
  },
  getAllGroup: {
    method: 'post',
    url: '/client/company/group/get-all'
  },
  addGroup: {
    method: 'post',
    url: '/client/company/group/create'
  },
  editGroup: {
    method: 'put',
    url: '/client/company/group/edit'
  },
  updatePermissions: {
    method: 'put',
    url: '/client/company/group/update-permission'
  },
  deleteGroup: {
    method: 'delete',
    url: '/client/company/group/delete'
  }
}
